import { getCategoryText, getLivingSpace } from '@habity/services';
import { NestedHome } from '@habity/types';
import { HomeDataBuilder } from './data-builder';
import { generalFields } from './general-fields';

export const getGeneralData = (home: NestedHome) => {
  if (!home) return [];

  const builder = new HomeDataBuilder(home)
    .addFields(generalFields);

  return builder.build();
};

export const getGeneralDescription = (home: NestedHome) => {
  const { living_space, category } = home?.address || {};
  return `${getCategoryText(category)} på ${getLivingSpace(living_space)}`;
};
